module.exports = __webpack_public_path__ + "img/icon-info-24px.c256b622.svg";